import React, { useEffect, useState, memo } from 'react'
import { Link } from 'react-router-dom'
import CustomButton from './CustomButton'
import store from '../../../redux/store'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { useSelector, useDispatch } from 'react-redux'
import { updateCartItems } from '../../../redux/actions/cartAction'
import ProductImg from '../../../assets/images/200x200.jpg'
import oilFilterImg from '../../../assets/images/placeholderImages/OilFilter.png'
import airFilterImg from '../../../assets/images/placeholderImages/AirFilter.png'
import cabinAirFilterImg from '../../../assets/images/placeholderImages/CabinAirFilter.png'
import fuelFilterImg from '../../../assets/images/placeholderImages/FuelFilter.png'
import transmissionFilterImg from '../../../assets/images/placeholderImages/TransmissionFilter.png'
import drainPlugImg from '../../../assets/images/placeholderImages/drainPlug.png'
import oilCapImg from '../../../assets/images/placeholderImages/oilCap.png'
import wiperBladeImg from '../../../assets/images/placeholderImages/wiperBlade.png'

import './MiniCart.scss'
import { FaPlus, FaMinus } from 'react-icons/fa'
import toastr from 'toastr'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { IoClose } from 'react-icons/io5'
import { getInventoryQty, getPrice, shouldShowPrice } from '../../../helpers/apiHandler'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

let searchTimer

function MiniCartItem({ product, key, handleQuantity, removeItemQuantity, addItemQuantity, showSidebar, customerId, handleCartUpdate }) {
  const [quantityState, setQuantityState] = useState(product.quantity || 0)
  const productUrl = `${product.partCategory}/${product.partSubCategory}/${product?.PartTerminologyName?.toLowerCase()
    .split(' ')
    .join('-')}-${product?.partNumber}?partId=${product?.part_id}`

  useEffect(() => {
    setQuantityState(product.quantity)
  }, [product.quantity])

  const handleQuantityInput = (e, totalQty) => {
    e.preventDefault()
    const inputQuantity = parseInt(e.target.value)
    if (inputQuantity > totalQty) {
      toastr?.error('No more quantity Available', 'QUANTITY UNAVIABALE')
    } else if (inputQuantity >=0) {
      setQuantityState(inputQuantity)
    } else if (isNaN(inputQuantity)) {
      setQuantityState('')
    }
    if (searchTimer) {
      clearTimeout(searchTimer)
    }
    searchTimer = setTimeout(() => {
      handleQuantity(e, product)
    }, 500)
  }

  const handleFocusOut = e => {
    if (e.target.value === '') {
      setQuantityState(product.quantity)
    }
  }
  // ------------------------------------------Conditional product image function---------------------------------

  const conditionalProductImg = () => {
    const { categoryName, subCategoryName, brandName, partCategory, partSubCategory } = product

    if ((categoryName === 'Filters' || partCategory === 'filters') && (brandName === 'Premium Guard' || brandName === 'ECOGARD')) {
      if (subCategoryName === 'Oil Filter' || partSubCategory === 'oil-filter') {
        return oilFilterImg;
      } else if (subCategoryName === 'Air Filter' || partSubCategory === 'air-filter') {
        return airFilterImg;
      } else if (subCategoryName === 'Cabin Air Filter' || partSubCategory === 'cabin-air-filter') {
        return cabinAirFilterImg;
      } else if (subCategoryName === 'Fuel Filter' || partSubCategory === 'fuel-filter') {
        return fuelFilterImg;
      } else if (subCategoryName === 'Transmission' || partSubCategory === 'transmission') {
        return transmissionFilterImg;
      } else if (subCategoryName === 'Drain Plugs and Gaskets' || partSubCategory === 'drain-plugs-and-gaskets') {
        return drainPlugImg;
      } else if (subCategoryName === 'Oil Filter Housing Caps' || partSubCategory === 'oil-filter-housing-caps') {
        return oilCapImg;
      }
    } else if ((categoryName === 'Wiper Blades' || partCategory === 'wiper-blades') && (subCategoryName === 'Wiper Blades' || subCategoryName === 'Rear Wiper Blade' || partSubCategory === 'wiper-blades' || partSubCategory === 'rear-wiper-blade') && (brandName === 'Premium Guard' || brandName === 'ECOGARD')) {
      return wiperBladeImg;
    }

    return ProductImg;
  }

  return <div
    className="row container mini_cart_product_card"
    key={key}
  >
    {
      product.images.length > 0
        ? <div className="col-md-3 img_container">
          <LazyLoadImage
            onClick={e => showSidebar(e, productUrl)}
            alt=""
            effect="blur"
            src={product.images[0].imageUrl ? product.images[0].imageUrl : product.images[0]}
            className="mini_cart__product_image" />
        </div>
        : <div className="col-md-3 img_container">
          <LazyLoadImage
            alt="product"
            effect="blur"
            src={conditionalProductImg()}
            className="mini_cart__product_image" />
        </div>
    }
    <div className="col-md-7 info_container">
      <div className="pl-3">
        <div className="line_one">
          {product.brandName ? product.brandName : '--'}
        </div>
        <div className="line_two cursor-pointer" onClick={e => showSidebar(e, productUrl)}>
          {product.PartTerminologyName ? product.PartTerminologyName : '--'}, {product.descirptionTwo ? product.descirptionTwo : '--'}
        </div>
        <div className="line_three">
          Part No. <span className='mini-cart-part-no' onClick={e => showSidebar(e, productUrl)}>{product.partNumber ? product.partNumber : '--'}</span>
        </div>
        <div className="quantity d-flex align-items-center">
          <div className='mr-2'>QTY:</div>
          <div className="quantity__input__container">
            <FaMinus
              className={`products__minus minicart-quantity-btn ${product?.quantity === 1 && 'disable__minus'
                }`}
              onClick={e => removeItemQuantity(product, e)}
            />
            <input
              min={0}
              max={getInventoryQty(product?.staffPriceData, product?.inventoryQuantity)}
              type="number"
              className="quantity__input all-product-quantity-input minicart-input-quantity"
              value={quantityState}
              onChange={(e, totalQty = getInventoryQty(product?.staffPriceData, product?.inventoryQuantity)) =>
                handleQuantityInput(e, totalQty)
              }
              onBlur={handleFocusOut}
            ></input>
            <FaPlus
              className="products__plus minicart-quantity-btn"
              onClick={e => addItemQuantity(product, e)}
            />
          </div>
          {/* {product.quantity ? product.quantity : '--'} */}
        </div>
        {
          shouldShowPrice() && (
            <div className="line_four">
            <span className="Each">
              Each{' '}
            </span>
            <span className="total"> {
              getPrice(product?.staffPriceData, product?.sell_price)
                ? <NumberFormat
                  value={getPrice(product?.staffPriceData, product?.sell_price)}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={'$'}
                />
                : '--'
            } </span>
          </div>
          )
        }
      </div>
    </div>

    <div className="col-md-1 trash_container">
      <LazyLoadImage
        alt="Trash"
        role="button"
        className="trash"
        effect="blur"
        src="/image/trash (1).svg"
        onClick={(e, vendorId = customerId, partId = product.part_id, quantity = 0) => handleCartUpdate(e, vendorId, partId, quantity)} />
    </div>
  </div>
}

const MiniCart = (props) => {
  const dispatch = useDispatch()
  const cartItems = useSelector((state) => state.cart)
  const [cartData, setCartData] = useState()
  const state = store.getState()
  const [customerId, setCustomerId] = useState(null)
  const [cartConfig, setCartConfig] = useState({ value: null, note: '' });
  const totalPrice = cartItems.data.reduce((acc, item) => {
    acc += parseFloat(item.total)
    return acc
  }, 0)

  const totalQuantity = cartItems.data.reduce((acc, item) => {
    acc += parseInt(item.quantity)
    return acc
  }, 0)

  useEffect(() => {
    setCartData(cartItems.data)
  }, [cartItems])

  // dispatch post related action for cart
  const handleCartUpdate = (e, vendorId, partId, quantity) => {
    const body = {
      vendorId,
      part_id: partId,
      quantity
    }
    dispatch(updateCartItems(body))
  }

  useEffect(() => {
    if (state.auth.isAuthenticated) {
      const { customerId } = JSON.parse(localStorage.getItem('profile'))
      setCustomerId(customerId)

      const { orderConfiguration } = JSON.parse(localStorage.getItem('commonData'));
      const { priceEnabled } = JSON.parse(localStorage.getItem('profile'));
  
      const configCode = priceEnabled === 1 ? "MIN_CART_TOTAL" : "MIN_CART_QTY";
      
      const selectedConfig = orderConfiguration.find(config => config.code === configCode);
      if (selectedConfig) {
          setCartConfig({ value: selectedConfig.value, note: selectedConfig.note, code: selectedConfig.code });
      }
    }
  }, [state.auth.isAuthenticated])

  const addItemQuantity = (productData, e) => {
    e.preventDefault()
    if (parseInt(productData?.quantity) < parseInt(getInventoryQty(productData?.staffPriceData, productData?.inventoryQuantity))) {
      const data = {
        part_id: productData.part_id,
        quantity: parseInt(productData.quantity) + 1,
        vendorId: productData.vendorId
      }
      dispatch(updateCartItems(data))
    } else {
      toastr?.error('No more quantity Available', 'QUANTITY UNAVIABALE')
    }
  }

  const removeItemQuantity = (productData, e) => {
    e.preventDefault()
    const data = {
      part_id: productData.part_id,
      quantity: parseInt(productData.quantity) - 1,
      vendorId: productData.vendorId
    }
    dispatch(updateCartItems(data))
  }

  const handleQuantity = (e, data) => {
    const product = {
      part_id: data.part_id,
      quantity: parseInt(e.target.value),
      vendorId: data.vendorId
    }
    if (e.target.value.length > 0) {
      dispatch(updateCartItems(product))
    }
    // dispatch(updateCartItems(product))
  }

  const renderSkeleton = () => (
    Array.from({ length: 3 }).map((_, index) => (
      <div className="row container mini_cart_product_card" key={index}>
        <div className="col-md-3 img_container">
          <Skeleton className="mini_cart__product_image" height={80} width={80} />
        </div>
        <div className="col-md-7 info_container">
          <div className="pl-3">
            <div className="line_one">
              <Skeleton width={120} />
            </div>
            <div className="line_two">
              <Skeleton width="80%" />
            </div>
            <div className="line_three">
              <Skeleton width={100} />
            </div>
            <div className="quantity d-flex align-items-center">
              <div className="mr-2">
                <Skeleton width={40} />
              </div>
              <div className="quantity__input__container">
                <Skeleton width={30} />
                <Skeleton width={30} className="mx-2" />
                <Skeleton width={30} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-1 trash_container">
          <Skeleton height={30} width={30} />
        </div>
      </div>
    ))
  );
  
  return (
    <div className="d-none d-lg-block position-relative" ref={props.closeMiniCart}>
      <div className={props.toggleSidebar ? 'mini_cart open' : 'mini_cart'}>
        <div className="mini-cart_header d-flex justify-content-between px-4 py-4 ">
          <span className="mini_cart__header_heading">
            SHOPPING CART <span className="mini_cart__number">({
              (!cartItems.loading && cartItems.data.length > 0) ? totalQuantity : '0'
            })</span>
          </span>
          <span
            className="mini_cart__close"
            onClick={props.showSidebar}
            role="button"
          >
            <IoClose />
          </span>
        </div>

        {state.auth.isAuthenticated
          ? (
            <>
              <div className="products minicart-height">
                {(!cartItems.loading && !cartItems.error) &&
                  <>
                    {
                      !cartItems?.quantityLoading ? (cartData?.length > 0 && cartData.map((product, i) => {
                        return (
                          <MiniCartItem product={product} key={i} handleQuantity={handleQuantity} addItemQuantity={addItemQuantity}
                            removeItemQuantity={removeItemQuantity} showSidebar={props.showSidebar} customerId={customerId}
                            handleCartUpdate={handleCartUpdate} />)
                      }))
                      : (
                        <div>
                          {renderSkeleton()}
                        </div>
                      )
                    }
                  </>}
              </div>
              <div
                className="mini_cart__footer container mt-2 bg-white"
                style={{ padding: '0 15px 30px 15px' }}
              >
                {
                  shouldShowPrice() && (
                    <div className="subtotal_container d-flex justify-content-between mt-3">
                    <span className="subtotal">SUBTOTAL</span>
                    <span className="subtotal_amount">
                      <NumberFormat
                        value={totalPrice}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$ '}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      /></span>
                  </div>
                  )
                }
                {(cartConfig?.code === 'MIN_CART_QTY' ? totalQuantity : totalPrice) < cartConfig?.value &&
                  <div className='error mb-2'>{`${cartConfig?.note} ${cartConfig?.value}`}</div>}
                <div className="navigator_buttons d-flex flex-row justify-content-between mt-4">
                  <div onClick={e => props.showSidebar(e, 'cart')}>
                    <CustomButton hoverColor="#4e4b4b">GO TO CART</CustomButton>
                  </div>
                  <div onClick={e => props.showSidebar(e, 'checkout')}>
                    <CustomButton disableButton={`${!(cartItems.data.length > 0) || (cartConfig?.code === 'MIN_CART_QTY' ? totalQuantity : totalPrice) < cartConfig?.value}`} background={`${(cartItems.data.length > 0 && (cartConfig?.code === 'MIN_CART_QTY' ? totalQuantity : totalPrice) >= cartConfig?.value) ? '#ed2c2b' : '#fbb6b5'}`} hoverColor={`${(cartItems.data.length > 0 && (cartConfig?.code === 'MIN_CART_QTY' ? totalQuantity : totalPrice) > cartConfig?.value) ? '#801919' : '#fbb6b5'}`} padding='10px 20px' >PROCEED TO CHECKOUT</CustomButton>
                  </div>
                </div>
              </div>
            </>
          )
          : (
            <>
              <div className="products-overlay-contents text-center">
                <p>Please Log in</p>
                <p className="mb-2">for price information.</p>
                <Link to="/login">
                  <button>Login</button>
                </Link>
              </div>
            </>
          )}
      </div>
    </div>
  )
}

MiniCart.propTypes = {
  closeMiniCart: PropTypes.any,
  toggleSidebar: PropTypes.any,
  showSidebar: PropTypes.any
}

MiniCartItem.propTypes = {
  product: PropTypes.any,
  key: PropTypes.number,
  handleQuantity: PropTypes.func,
  removeItemQuantity: PropTypes.func,
  addItemQuantity: PropTypes.func,
  showSidebar: PropTypes.func,
  customerId: PropTypes.any,
  handleCartUpdate: PropTypes.func
}

export default memo(MiniCart)
